import { StressLevel } from './gameStore';

export function generateRoomCode(): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // No confusing chars
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += chars[Math.floor(Math.random() * chars.length)];
  }
  return code;
}

export function generatePlayerNumbers(round: number, isOvershoot: boolean): [number, number] {
  if (isOvershoot) {
    // Negative numbers for overshoot recovery
    const num1 = -Math.floor(Math.random() * 10) - 1;
    const num2 = -Math.floor(Math.random() * 10) - 1;
    return [num1, num2];
  }

  let max = 20;
  if (round >= 7) max = 50;
  else if (round >= 4) max = 30;

  const num1 = Math.floor(Math.random() * max) + 1;
  const num2 = Math.floor(Math.random() * max) + 1;
  return [num1, num2];
}

export function getBackgroundState(currentTotal: number, targetTotal: number): 'below' | 'above' | 'perfect' {
  if (currentTotal === targetTotal) return 'perfect';
  if (currentTotal < targetTotal) return 'below';
  return 'above';
}

export function calculateStressLevel(currentTotal: number, targetTotal: number): StressLevel {
  const diff = Math.abs(currentTotal - targetTotal);
  if (diff <= 2) return 'calm';
  if (diff <= 10) return 'nervous';
  return 'panic';
}

export function getStressEmoji(stress: StressLevel): string {
  switch (stress) {
    case 'calm': return '😊';
    case 'nervous': return '😰';
    case 'panic': return '😱';
  }
}

export function getBackgroundColor(state: 'below' | 'above' | 'perfect'): string {
  switch (state) {
    case 'below': return 'bg-chaos-red/20';
    case 'above': return 'bg-chaos-yellow/20';
    case 'perfect': return 'bg-chaos-green/20';
  }
}
